var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcQuote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7826 5C17.1449 6.08614 17.3261 6.99126 17.3261 7.71536C17.3261 8.36705 17.2174 9.23596 17 10.3221C12.1449 10.3221 9.71739 12.8202 9.71739 17.8165C9.71739 19.6267 10.6594 20.6405 12.5435 20.8577C15.2971 21.0749 16.6739 22.8489 16.6739 26.1798C16.6739 28.7141 16.058 30.6692 14.8261 32.0449C13.6667 33.3483 11.529 34 8.41304 34C4.13768 34 2 31.1036 2 25.3109C2 19.5181 3.15942 14.7029 5.47826 10.8652C7.7971 6.95506 11.5652 5 16.7826 5ZM36.4565 5C36.8188 6.08614 37 6.99126 37 7.71536C37 8.36705 36.8913 9.23596 36.6739 10.3221C31.8188 10.3221 29.3913 12.8202 29.3913 17.8165C29.3913 19.6267 30.3333 20.6405 32.2174 20.8577C34.971 21.0749 36.3478 22.8489 36.3478 26.1798C36.3478 28.7141 35.7319 30.6692 34.5 32.0449C33.3406 33.3483 31.2029 34 28.087 34C23.8116 34 21.6739 31.1036 21.6739 25.3109C21.6739 19.5181 22.8333 14.7029 25.1522 10.8652C27.471 6.95506 31.2391 5 36.4565 5Z",
    fill: "#3A61BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcQuote);
export default __webpack_public_path__ + "static/media/ic-quote.4099e29c57a99ce2d58af4b95138a169.svg";
export { ForwardRef as ReactComponent };